import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { db } from '../firebase';
import { ref as dbRef, set, runTransaction } from "firebase/database";
import { translateToMarathi } from '../utils/translationUtils';

const EngineerRegistration = () => {
  const [formData, setFormData] = useState({
    surname: '',
    firstName: '',
    middleName: '',
    whatsappNo: '',
    userName: '',
    email: '',
    birthPlace: '',
    dob: '',
    taluka: '',
    aadharNo: '',
    panNo: '',
    gstNo: '',
    currentAddress: '',
    technicalQualification: '',
    trade: '',
    organizationName: '',
    universityName: '',
    passingYear: '',
    businessLocation: '',
    bankName: '',
    bankAddress: '',
    declaration: false
  });

  const [uploading, setUploading] = useState(false);
  const translationTimeoutRef = React.useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData(prev => {
      const updatedData = {
        ...prev,
        [name]: newValue
      };
      
      // Automatically set userName to whatsappNo value
      if (name === 'whatsappNo') {
        updatedData.userName = newValue;
      }
      
      return updatedData;
    });

    // Trigger translation ONLY for specific fields
    const translationFields = ['surname', 'firstName', 'middleName', 'currentAddress'];
    if (translationFields.includes(name)) {
      if (translationTimeoutRef.current) {
        clearTimeout(translationTimeoutRef.current);
      }

      const performTranslation = async (textValue) => {
        if (textValue.trim()) {
          const translated = await translateToMarathi(textValue);
          setFormData(prev => ({
            ...prev,
            [name]: translated // Replace original English with Marathi
          }));
        }
      };

      // If the last character is a space, translate immediately
      if (value.endsWith(' ')) {
        performTranslation(value);
      } else {
        // Otherwise, use debounce
        translationTimeoutRef.current = setTimeout(() => {
          performTranslation(value);
        }, 700);
      }
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);

    try {
      // 1. Generate 4-digit registration number
      const counterRef = dbRef(db, 'ekamwatapzp/Counters/EngineerRegistrationCount');
      const result = await runTransaction(counterRef, (currentCount) => {
        return (currentCount || 0) + 1;
      });

      const newCount = result.snapshot.val();
      const registrationNo = String(newCount).padStart(4, '0');

      // 2. Combine form data with metadata
      const finalData = {
        ...formData,
        registrationNo: registrationNo,
        status: 'pending',
        submittedAt: new Date().toISOString()
      };

      const engineerRef = dbRef(db, `ekamwatapzp/EngineerRegistrations/${formData.userName}`);
      await set(engineerRef, finalData);
      
      alert("नोंदणी यशस्वीरीत्या जतन केली आहे!");
      handleReset();
    } catch (error) {
      alert("त्रुटी: " + error.message);
    } finally {
      setUploading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      surname: '',
      firstName: '',
      middleName: '',
      whatsappNo: '',
      userName: '',
      email: '',
      birthPlace: '',
      dob: '',
      taluka: '',
      aadharNo: '',
      panNo: '',
      gstNo: '',
      currentAddress: '',
      technicalQualification: '',
      trade: '',
      organizationName: '',
      universityName: '',
      passingYear: '',
      businessLocation: '',
      bankName: '',
      bankAddress: '',
      declaration: false
    });
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />
      
      <main className="flex-grow py-12 px-4">
        <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl border border-yellow-200 overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-blue-50 to-white p-8 border-b border-gray-100 text-center">
            <h1 className="text-3xl font-extrabold text-blue-900 mb-2">महाराष्ट्र शासन</h1>
            <h2 className="text-2xl font-bold text-blue-800 mb-4">सांगली जिल्हा परिषद</h2>
            <div className="inline-block px-6 py-2 bg-blue-100 text-blue-900 rounded-full font-bold text-lg">
              कंत्राटदार म्हणून पदवी/डिप्लोमा अभियंत्यांच्या नोंदणीसाठी अर्ज.
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-8 md:p-12 space-y-10">
            {/* Personal Information Section */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <FormInput 
                label="अर्जदार आडनाव" 
                name="surname" 
                placeholder="अर्जदाराचे आडनाव प्रविष्ट करा" 
                required 
                value={formData.surname}
                onChange={handleChange}
              />
              <FormInput 
                label="पहिले नाव" 
                name="firstName" 
                placeholder="पहिले नाव प्रविष्ट करा" 
                required 
                value={formData.firstName}
                onChange={handleChange}
              />
              <FormInput 
                label="वडीलांचे नांव / पतीचे नांव" 
                name="middleName" 
                placeholder="वडीलांचे नांव प्रविष्ट करा" 
                required 
                value={formData.middleName}
                onChange={handleChange}
              />
              
              <FormInput 
                label="व्हॉट्सॲप नंबर" 
                name="whatsappNo" 
                placeholder="व्हॉट्सॲप नंबर प्रविष्ट करा" 
                required 
                value={formData.whatsappNo}
                onChange={handleChange}
              />
              <FormInput 
                label="युजर नेम" 
                name="userName" 
                placeholder="युजर नेम प्रविष्ट करा" 
                required 
                value={formData.userName}
                onChange={handleChange}
              />
              <FormInput 
                label="ई - मेल आयडी" 
                name="email" 
                type="email" 
                placeholder="ई - मेल आयडी प्रविष्ट करा" 
                required 
                value={formData.email}
                onChange={handleChange}
              />



              <FormInput 
                label="जन्म स्थान" 
                name="birthPlace" 
                placeholder="अर्जदाराचे जन्मस्थान प्रविष्ट करा" 
                value={formData.birthPlace}
                onChange={handleChange}
              />
              <FormInput 
                label="जन्मतारीख" 
                name="dob" 
                type="date" 
                required 
                value={formData.dob}
                onChange={handleChange}
              />
              <FormSelect 
                label="तालुका" 
                name="taluka" 
                options={[
                  { value: 'Miraj', label: 'मिरज' },
                  { value: 'Tasgaon', label: 'तासगाव' },
                  { value: 'Kavathe Mahankal', label: 'कवठे महांकाळ' },
                  { value: 'Walwa', label: 'वाळवा' },
                  { value: 'Shirala', label: 'शिराळा' },
                  { value: 'Khanapur', label: 'खानापूर' },
                  { value: 'Atpadi', label: 'आटपाडी' },
                  { value: 'Jat', label: 'जत' },
                  { value: 'Kadegaon', label: 'कडेगाव' },
                  { value: 'Palus', label: 'पलूस' }
                ]} 
                required 
                value={formData.taluka}
                onChange={handleChange}
              />

              <FormInput 
                label="आधार क्रमांक" 
                name="aadharNo" 
                placeholder="आधार क्रमांक प्रविष्ट करा" 
                required 
                value={formData.aadharNo}
                onChange={handleChange}
              />
              <FormInput 
                label="पॅन क्रमांक" 
                name="panNo" 
                placeholder="पॅन क्रमांक प्रविष्ट करा" 
                required 
                value={formData.panNo}
                onChange={handleChange}
              />
              <FormInput 
                label="जी.एस.टी क्रमांक" 
                name="gstNo" 
                placeholder="जी.एस.टी क्रमांक प्रविष्ट करा" 
                value={formData.gstNo}
                onChange={handleChange}
              />
            </div>

            <div className="w-full">
              <label className="block text-gray-700 font-bold mb-2">सध्याचा पत्ता <span className="text-red-500">*</span></label>
              <textarea 
                name="currentAddress"
                rows="3" 
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                placeholder="सध्याचा पत्ता प्रविष्ट करा"
                required
                value={formData.currentAddress}
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Qualification Section */}
            <div className="pt-8 border-t border-gray-100">
              <h3 className="text-2xl font-bold text-blue-900 mb-8 text-center">पात्रता तपशील</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <FormSelect 
                  label="तांत्रिक पात्रता" 
                  name="technicalQualification" 
                  options={[
                    { value: 'Degree', label: 'पदवी (Degree)' },
                    { value: 'Diploma', label: 'डिप्लोमा (Diploma)' }
                  ]} 
                  required 
                  value={formData.technicalQualification}
                  onChange={handleChange}
                />
                <FormSelect 
                  label="ट्रेड" 
                  name="trade" 
                  options={[
                    { value: 'Civil', label: 'सिव्हिल (Civil)' },
                    { value: 'Mechanical', label: 'मेकॅनिकल (Mechanical)' },
                    { value: 'Electrical', label: 'इलेक्ट्रिकल (Electrical)' }
                  ]} 
                  required 
                  value={formData.trade}
                  onChange={handleChange}
                />
                <FormInput 
                  label="संस्थेचे नाव" 
                  name="organizationName" 
                  placeholder="संस्थेचे नाव प्रविष्ट करा" 
                  value={formData.organizationName}
                  onChange={handleChange}
                />

                <FormInput 
                  label="विद्यापीठाचे नाव" 
                  name="universityName" 
                  placeholder="विद्यापीठाचे नाव प्रविष्ट करा" 
                  value={formData.universityName}
                  onChange={handleChange}
                />
                <FormInput 
                  label="उत्तीर्ण वर्ष" 
                  name="passingYear" 
                  placeholder="उत्तीर्ण वर्ष प्रविष्ट करा" 
                  value={formData.passingYear}
                  onChange={handleChange}
                />
                <FormInput 
                  label="व्यवसायाचे ठिकाण" 
                  name="businessLocation" 
                  placeholder="व्यवसायाचे ठिकाण प्रविष्ट करा" 
                  required 
                  value={formData.businessLocation}
                  onChange={handleChange}
                />

                <FormInput 
                  label="बँकेचे नाव" 
                  name="bankName" 
                  placeholder="बँकेचे नाव प्रविष्ट करा" 
                  required 
                  value={formData.bankName}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-8">
                <FormInput 
                  label="बँकेचा पत्ता" 
                  name="bankAddress" 
                  placeholder="बँकेचा पत्ता प्रविष्ट करा" 
                  fullWidth
                  value={formData.bankAddress}
                  onChange={handleChange}
                />
              </div>
            </div>


            {/* Declaration Section */}
            <div className="bg-blue-50 p-6 rounded-xl border border-blue-100">
               <div className="flex items-start space-x-4">
                  <input 
                    type="checkbox" 
                    id="declaration" 
                    name="declaration"
                    className="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500 border-gray-300"
                    checked={formData.declaration}
                    onChange={handleChange}
                  />
                  <label htmlFor="declaration" className="text-blue-900 font-medium leading-relaxed">
                    मी प्रमाणित करतो/करते की मी त्यापेक्षा जास्त विभागात कंत्राटदार म्हणून माझी नोंदणी केलेली नाही/करणार नाही.
                  </label>
               </div>
            </div>

            {/* Submit Actions */}
            <div className="flex justify-end space-x-4 pt-8">
               <button 
                  type="submit" 
                  disabled={uploading}
                  className={`${uploading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-900 hover:bg-blue-800'} text-white px-10 py-3 rounded-lg font-bold shadow-lg transition transform hover:scale-105`}
               >
                  {uploading ? 'Uploading...' : 'Submit'}
               </button>
               <button 
                  type="button" 
                  onClick={handleReset}
                  className="bg-gray-500 hover:bg-gray-600 text-white px-10 py-3 rounded-lg font-bold shadow-lg transition transform hover:scale-105"
               >
                  Reset
               </button>
            </div>
          </form>
        </div>
      </main>

      <Footer />
    </div>
  );
};

// Helper Components
const FormInput = ({ label, name, placeholder, type = "text", required = false, fullWidth = false, value, onChange }) => (
  <div className={fullWidth ? "w-full" : ""}>
    <label className="block text-gray-700 font-bold mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input 
      type={type} 
      name={name}
      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
      placeholder={placeholder}
      required={required}
      value={value}
      onChange={onChange}
    />
  </div>
);

const FormSelect = ({ label, name, options, required = false, value, onChange }) => (
  <div>
    <label className="block text-gray-700 font-bold mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <select 
      name={name}
      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition bg-white"
      required={required}
      value={value}
      onChange={onChange}
    >
      <option value="">निवडा</option>
      {options.map((opt, idx) => (
        <option key={idx} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);



export default EngineerRegistration;
